import type { PortfolioSummary } from "./usePortfolio";
import { Shimmer } from "../../ui/loaders";
import { fmtPct, fmtRub } from "../../lib/format";

// 4 KPI-карточки сверху портфеля — структура из direction A прототипа.
// Последняя «ожидается до horizon» — с лёгкой акцентной подложкой, чтобы
// эта проактивная цифра выделялась среди backward-looking метрик.
export function SummaryCards({ summary }: { summary: PortfolioSummary | undefined }) {
  const loading = summary == null;
  const pl = summary?.total_unrealized_pnl_rub ?? 0;
  const plClass = !loading ? (pl > 0 ? "ok" : pl < 0 ? "bad" : "") : "";
  const plPct = summary?.total_unrealized_pnl_pct ?? null;

  return (
    <div className="grid g-4" style={{ gap: 10, marginBottom: 14 }}>
      <div className="card" style={{ padding: 14 }}>
        <div className="label">позиций</div>
        <div className="big-num" style={{ fontSize: 38 }}>
          {loading ? <Shimmer width={60} height={36} /> : summary!.position_count}
        </div>
      </div>
      <div className="card" style={{ padding: 14 }}>
        <div className="label">текущая стоимость</div>
        <div className="big-num" style={{ fontSize: 26 }}>
          {loading ? (
            <Shimmer width={140} height={26} />
          ) : (
            fmtRub(summary!.total_market_value_rub)
          )}
        </div>
        <div className="soft" style={{ fontSize: 12, marginTop: 4 }}>
          {loading ? (
            <Shimmer width={120} height={12} />
          ) : (
            <>вложено {fmtRub(summary!.total_cost_basis_rub)}</>
          )}
        </div>
      </div>
      <div className="card" style={{ padding: 14 }}>
        <div className="label">нереализ. P&amp;L</div>
        <div className={`big-num ${plClass}`} style={{ fontSize: 26 }}>
          {loading ? (
            <Shimmer width={140} height={26} />
          ) : (
            <>
              {pl >= 0 ? "+" : ""}
              {fmtRub(pl)}
            </>
          )}
        </div>
        <div className={`${plClass}`} style={{ fontSize: 12, marginTop: 4 }}>
          {loading ? (
            <Shimmer width={70} height={12} />
          ) : plPct == null ? (
            "—"
          ) : (
            `${plPct >= 0 ? "+" : ""}${fmtPct(plPct)}`
          )}
        </div>
      </div>
      <div
        className="card"
        style={{
          padding: 14,
          background:
            "linear-gradient(180deg, rgba(29,78,137,0.08), transparent)",
        }}
      >
        <div className="label">ожидается до horizon</div>
        <div className="big-num accent" style={{ fontSize: 26 }}>
          {loading ? (
            <Shimmer width={140} height={26} />
          ) : (
            <>+{fmtRub(summary!.total_expected_return_rub)}</>
          )}
        </div>
        <div className="soft" style={{ fontSize: 12, marginTop: 4 }}>
          купоны + погашения, после налога
        </div>
      </div>
    </div>
  );
}
